import React, { Component } from 'react';
import { connect } from 'react-redux';
import { autobind } from '../utils';
import actions from '../actions';
import SvgIcon from '../presentation/SvgIcon';
import DownArrowIcon from '../assets/images/svgs/down-arrow.svg';

@connect((state) => {
    return {
        emailEnterpriseMap: state.emailEnterpriseMap,
    }
})
export default class CreateMapping extends Component {
    constructor(props) {
        super(props);
        autobind(['closeOverlay', 'saveMapping', 'toggleEnterpriseDropdown', 'handleChange'], this);
        this.state = {
            email: "",
            enterpriseId: "",
            validationErrors: {},
            selectedEnterprise: {},
            showEnterpriseDropdown: false,
            disableSend: false
        }
    }

    handleChange(key, value) {
        this.setState({
            [key]: value
        });
    }

    validateField(field) {
        let fieldValue = this.state[field];
        const emailEnterpriseMap = this.props.emailEnterpriseMap;
        const validationErrors = this.state.validationErrors;
        switch(field) {
            case "email":
                const checkEmailId = obj => obj.email == fieldValue;
                const checkEmailExists = emailEnterpriseMap.mapList.some(checkEmailId);

                const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if(!fieldValue || !emailRegex.test(fieldValue)) {
                    validationErrors[field] = "Please enter a valid email address";
                    this.setState({
                      validationErrors,
                      disableSend: true
                    });
                    return;
                }
                else if(checkEmailExists){
                  validationErrors[field] = `Only one-on-one mapping for now. This email id is already mapped to an Enterprise. Use another email address.` ;
                  this.setState({
                    validationErrors,
                    disableSend: true
                  });
                  return;
                }
                break;
            default:
                break;
        }
        delete validationErrors[field];
        this.setState({
          validationErrors,
          disableSend: false
        });
    }

    selectEnterprise(enterprise) {
        this.setState({
            selectedEnterprise: enterprise,
            showEnterpriseDropdown: false
        });
    }

    toggleEnterpriseDropdown() {
        this.setState({
            showEnterpriseDropdown: !this.state.showEnterpriseDropdown
        });
    }

    saveMapping() {
        this.props.addMapElement({
            email: this.state.email,
            enterpriseName: this.state.selectedEnterprise.name,
            enterpriseId: this.state.selectedEnterprise._id
        });
        this.props.dispatch({ type: actions.HIDE_OVERLAY });
    }

    closeOverlay() {
        this.props.dispatch({ type: actions.HIDE_OVERLAY });
    }

    render() {
        const validationErrors = this.state.validationErrors;
        const { disableSend } = this.state;

        return (
            <div className="pop-up-content create-mapping-container vflex jfs ast">
               <div className="title-container">
                    <p className="title">Create Mapping</p>
                    {this.props.subMessage && <p className="subtitle">Any email from this email address will be sent to the chosen enterprise</p>}
                </div>
                <form className="map-form">
                    <div className={validationErrors.email ? "input-container invalid" : "input-container"}>
                        <input type="email" placeholder="Email" value={this.state.email} className="input-field" onBlur={this.validateField.bind(this, "email")} onChange={(event) => this.handleChange("email", event.target.value)} />
                        {validationErrors.email && <p className="input-validation-error">{validationErrors.email}</p>}
                    </div>
                    <div className="input-container custom-dropdown-container">
                        <div className="selected-option-container hflex jsb" onClick={this.toggleEnterpriseDropdown}>
                            <p className="selected-option">{this.state.selectedEnterprise.name ? this.state.selectedEnterprise.name : "Select Enterprise"}</p>
                            <SvgIcon glyph={DownArrowIcon} width='16px' height='10px'/>
                        </div>
                        {this.state.showEnterpriseDropdown &&
                            <ul className="custom-dropdown">
                                {this.props.enterprises.enterprisesList.map((enterprise, idx) => {
                                    return (<li className="dropdown-option" key={idx} onClick={this.selectEnterprise.bind(this, enterprise)}>{enterprise.name}</li>)
                                })}
                            </ul>
                        }
                    </div>
                </form>
                <div className="actions-container hflex">
                    <button type="button"  disabled={disableSend} className="action-btn btn btn-primary" onClick={this.saveMapping}>Save</button>
                    <button type="button" className="action-btn btn btn-negative" onClick={this.closeOverlay}>Cancel</button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/CreateMapping.js